import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useParams } from "react-router-dom";
import useHomeStore from "../components/ZustandStore/useHomeStore";

const DynamicMetaTags = ({ endpoint }) => {
  const { metaTags, fetchData } = useHomeStore(); // Access Zustand store
  const location = useLocation(); // Get the current route location
  const { slug } = useParams(); // Get the slug from URL params (if present)

  // Fetch meta tags based on the endpoint when the component mounts or when the location/slug changes
  useEffect(() => {
    if (endpoint) {
      fetchData(endpoint); // Make sure endpoint is passed properly
    }
  }, [fetchData, endpoint]); // Re-run when endpoint changes
  // Decide which meta tag to use based on the location or slug
  let pageTitle, pageDescription, keywords;

  if (location.pathname === "/") {
    // Home page (root path "/")
    pageTitle = metaTags.homePageSetting?.metaTitle || "Default Home Title";
    pageDescription =
      metaTags.homePageSetting?.metaDescription || "Default Home Description";
    keywords = metaTags.homePageSetting?.keywords || "Default Home Keywords";
  } else if (location.pathname.startsWith("/product")) {
    // Product page (slug-based path)
    pageTitle = metaTags.metaTitle || "Default Product Title";
    pageDescription = metaTags.metaDescription || "Default Product Description";
    keywords = metaTags.keywords || "Default Product Keywords";
  } else if (location.pathname.startsWith("/category")) {
    pageTitle = metaTags.metaTitle || "Default Product Title";
    pageDescription = metaTags.metaDescription || "Default Product Description";
    keywords = metaTags.keywords || "Default Product Keywords";
  }

  console.log("metaTags", metaTags); // Log metaTags for debugging

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

export default DynamicMetaTags;
